import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import '../styles/common/Parents.css';

import Header from '../components/common/Header.jsx';
import Footer from '../components/common/Footer.jsx';
import TabsSection from '../components/common/TabsSection';

import hero from '../assets/parents/hero.svg';
import hero2 from '../assets/teachers/hero.svg';
import phone from '../assets/parents/phone-hand.svg';
import footerImg from '../assets/parents/footerImg.svg';

const slides = [
    '«Я сама це в школі не любила, а тепер ще й треба якось пояснити дитині».',
    '«Кажу, що треба вчитися, а у відповідь: “Навіщо мені ця математика? Я буду блогеркою».',
    '«Грошей на репетитора немає, а розібратися якось треба».',
    '«Робили задачу всією родиною — і так нічого й не зробили».'
];

const fearItems = [
    'Що таке математична тривожність і як вона проявляється',
    'Чому дитина може «закриватися», навіть коли знає матеріал',
    'Як підтримувати словами й діями та не підживлювати страх',
    'Як повернути впевненість'
];

export default function ParentsPage() {
    const scrollReveal = {
        offscreen: { 
            y: 60, 
            opacity: 0 
        },
        onscreen: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                bounce: 0.3,
                duration: 1
            }
        }
    };
    return (
        <div className="page-container parents">
            <Header />
            <section className="banner">
                <h1 className="banner__title">БігМат для&nbsp;батьків</h1>
                <div className="banner__container">
                    <div className="banner__text">
                        <p>Підтримуйте дитину у вивченні математики спокійно й упевнено — без&nbsp;тиску та конфліктів через домашні завдання.</p>
                        <p>Починаємо з теми «Вступ до дробів» — однієї з ключових для 5–6 класів.</p>
                    </div>
                    <motion.div 
                        className="banner__img-wrapper"
                        initial={{ x: 200, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ 
                            duration: 0.8,
                            ease: "easeOut"
                        }}
                    >
                        <img src={hero} alt=""/>
                        <div className="parents__info-badge">
                            <div className="info-badge__dots">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <p className="info-badge__text">
                                Зовсім скоро з’являться матеріали й для інших тем.
                            </p>
                        </div>
                    </motion.div>
                </div>
            </section>

            <motion.section className="parents__section  reviews"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <h2 className="parents__section-title">Менше стресу — більше результату</h2>
                <div className="reviews-slider-container">
          
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        spaceBetween={50}
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                        delay: 3500,
                        disableOnInteraction: true,
                        pauseOnMouseEnter: true,
                        }}
                        navigation={{
                        nextEl: '.review-button-next',
                        prevEl: '.review-button-prev',
                        }}
                        className="review-swiper"
                    >
                        {slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div className="review-bubble" id={`review-${index}`}>
                                <p>{slide}</p>
                            </div>
                        </SwiperSlide>
                        ))}
                    </Swiper>

                    <button className="review-nav-btn review-button-prev">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <button className="review-nav-btn review-button-next">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </button>

                    </div>
                    <p className="reviews-text">
                        БігМат допомагає батькам краще розуміти дитину та знати, як підтримати її і допомогти.
                    </p>
            </motion.section>

            <motion.section className="parents__section fear"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <h2 className="parents__section-title">Дитина боїться математики?</h2>
                <p className="fear__text">Імовірно, це математична тривожність.</p>
                
                <div className="banner">
                    <div className="banner__container">
                        <motion.img 
                            alt="Hero" 
                            src={hero2} 
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ 
                                duration: 0.8,
                                ease: "easeOut"
                            }}
                        />
                        <div className="banner__comment">
                            <p>
                                Це не «відсутність хисту» і не лінь.
                                Поширена причина математичної тривожності — <b style={{fontWeight: 700}}>негативний досвід: </b> 
                                невдалий коментар дорослого, порівняння з іншими, складна контрольна 
                                після лікарняного тощо.
                            </p>
                        </div>
                    </div>
                </div>
                <p className="fear__text">
                    Хочете краще розуміти, що відбувається з вашою дитиною? Подивіться відео, у якому психолог пояснює:
                </p>
                <div className="fear__container">
                    {
                        fearItems.map((item, index) => (
                            <div className="fear__item" key={index}>
                                <p>{item}</p>
                            </div>
                        ))
                    }
                </div>

                {/* <div className="video-container">
                    <svg className="video-placeholder" width="1081" height="610" viewBox="0 0 1081 610" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="1081" height="610" rx="20" fill="#0F2D4D"/>
                    <path d="M567 305L526.5 328.383L526.5 281.617L567 305Z" fill="#F3F3EC"/>
                    <circle cx="540.5" cy="305.5" r="56" stroke="#F3F3EC"/>
                </svg>
                </div> */}

            </motion.section>

            <motion.section className="parents__section kids-app"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <h2 className="parents__section-title">Допомогти розібратися з&nbsp;математикою легко</h2>
                <div className="kids-app__wrapper">
                    <div className="kids-app__list">
                        <p>Запропонуйте дитині застосунок</p>
                        <p>Скористайтеся корисними матеріалами нижче</p>
                    </div>
                    <img src={phone} alt=""/>
                </div>
            </motion.section>

            <motion.section 
                className="tabs-parents"
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.2 }}
                variants={scrollReveal}
            >
                <div className="tabs-parents-text">
                    <h2 className="parents__section-title">Корисні матеріали з теми «Вступ до дробів»</h2>
                    <span className="home__sticker-note">Скоро — більше</span>
                </div>
                <p className="tabs-subtitle"><b>Дроби без стресу:</b><br/> через гру, щоденні ситуації та розмови.</p>
                <TabsSection/>
            </motion.section>    

            <Footer 
                image={footerImg} 
                text="Підтримувати, а не тиснути" 
                shouldDecorate={false} 
            />
        </div>    
    )
}